module.exports = __webpack_public_path__ + "akne_7_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/akne_7_after_tn.jpg
// module id = 1395
// module chunks = 0